/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Charterer_Representative_TitleInputs */



/**
* | output |
* | --- |
* | "Charterer's representative" |
*
* @param {Service_Charterer_Representative_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_charterer_representative_title = /** @type {((inputs?: Service_Charterer_Representative_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Charterer_Representative_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("租家代表")
	return /** @type {LocalizedString} */ ("Charterer's representative")
});